import React from "react";
import { BILLING_DISPLAY_FORMAT } from "repoV2/features/Listing/Listing.constants";
import dynamic from "next/dynamic";
import { useCheckoutPriceDetailsContext } from "../CheckoutPriceDetailsContextProvider";
import useHideGrandTotal from "./utils/useHideGrandTotal";

const StandardPaymentSummary = dynamic(
    () => import("./modules/StandardPaymentSummary/StandardPaymentSummary")
);

const SplitPaymentSummary = dynamic(
    () => import("./modules/SplitPaymentSummary/SplitPaymentSummary")
);

const GatewayPaymentSummary = dynamic(
    () => import("./modules/GatewayPaymentSummary/GatewayPaymentSummary")
);

const PaymentSummarySection = () => {
    const { gstSummaryType: billingDisplayFormat } =
        useCheckoutPriceDetailsContext();

    const { hideGrandTotalSection = false } = useHideGrandTotal();

    if (hideGrandTotalSection) {
        return <></>;
    }

    return (
        <>
            {billingDisplayFormat ===
            BILLING_DISPLAY_FORMAT.DEFAULT_SHOW_ALL ? (
                <StandardPaymentSummary />
            ) : null}
            {billingDisplayFormat === BILLING_DISPLAY_FORMAT.SEPARATE_CGST ? (
                <SplitPaymentSummary />
            ) : null}
            {billingDisplayFormat ===
            BILLING_DISPLAY_FORMAT.PRETEND_CGST_INAPPLICABLE ? (
                <GatewayPaymentSummary />
            ) : null}
        </>
    );
};

export default PaymentSummarySection;
